<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>NEW YORK UNIVERSITY PRESS</p>
<p class="crt">New York</p>
<p class="crt"><a class="url" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="crtf">© 2021 by New York University</p>
<p class="crt">All rights reserved</p>
<p class="crtf">References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Williams, Rhys H., editor. | Haberski, Raymond J., 1968– editor. | Goff, Philip, 1964– editor.</p>
<p class="cip">Title: Civil religion today : religion and the American nation in the twenty-first century / Rhys H. Williams, Raymond Haberski Jr., Philip Goff, [editors].</p>
<p class="cip">Description: New York : New York University, [2021] | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2021016772 | ISBN 9781479809844 (hardback) | ISBN 9781479809851 (paperback) | ISBN 9781479809882 (ebook) | ISBN 9781479809868 (ebook other)</p>
<p class="cip">Subjects: LCSH<span class="sm">:</span> Civil religion—United States—History—21st century.</p>
<p class="cip">Classification: LCC BL2525 .C584 2021 | DDC 201/.720973—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2021016772" target="_blank">https://lccn.loc.gov/2021016772</a></p>
<p class="crtf">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="crtf">Manufactured in the United States of America</p>
<p class="crtf">10 9 8 7 6 5 4 3 2 1</p>
<p class="crtf">Also available as an ebook</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// williamsCivilReligion-0004.vue?32278838